module.exports = __webpack_public_path__ + "prod/1.42.2/img/plan_case2x.a6d10982.png";